"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMultiCoinRewardsConverters = void 0;
var createMultiCoinRewardsConverters = function () {
    return {
        "/kyve.multi_coin_rewards.v1beta1.MsgSetMultiCoinRewardsDistributionPolicy": {
            aminoType: "kyve/multi_coin_rewards/MsgSetMultiCoinRewardsDistributionPolicy",
            toAmino: function (msg) { return ({
                creator: msg.creator,
                policy: msg.policy,
            }); },
            fromAmino: function (msg) { return ({
                creator: msg.creator,
                policy: msg.policy,
            }); },
        },
        "/kyve.multi_coin_rewards.v1beta1.MsgToggleMultiCoinRewards": {
            aminoType: "kyve/multi_coin_rewards/MsgToggleMultiCoinRewards",
            toAmino: function (msg) { return ({
                creator: msg.creator,
                enabled: msg.enabled,
            }); },
            fromAmino: function (msg) { return ({
                creator: msg.creator,
                enabled: msg.enabled,
            }); },
        },
        "/kyve.multi_coin_rewards.v1beta1.MsgUpdateParams": {
            aminoType: "kyve/multi_coin_rewards/MsgUpdateParams",
            toAmino: function (msg) { return ({
                authority: msg.authority,
                payload: msg.payload,
            }); },
            fromAmino: function (msg) { return ({
                authority: msg.authority,
                payload: msg.payload,
            }); },
        },
    };
};
exports.createMultiCoinRewardsConverters = createMultiCoinRewardsConverters;
//# sourceMappingURL=multi_coin_rewards.amino.js.map